import React, { useCallback, useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import { Modal } from "react-bootstrap";
import { PDFViewer } from "@react-pdf/renderer";
import LampTeknisCpib from "../../../cetak/pbumku/LampTeknisCpib";
import LampTeknisCbib from "../../../cetak/pbumku/LampTeknisCbib";
import LampTeknisCppib from "../../../cetak/pbumku/LampTeknisCppib";
import LampTeknisCpoib from "../../../cetak/pbumku/LampTeknisCpoib";
import LampTeknisCdoib from "../../../cetak/pbumku/LampTeknisCdoib";

const ModalPreviewPdf = ({ showPreview, handleClosePreview, dataPrimer, dataDisposisi, jenisIzin }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [dataOssHeader, setDataOssHeader] = useState(null)
    const [dataOssProyek, setDataOssProyek] = useState(null)
    // const [dataOssChecklist, setDataOssChecklist] = useState(null)
    const [dataIzin, setDataIzin] = useState(null)
    const [dataProyekLokasi, setDataProyekLokasi] = useState([])
    const [dataApproval, setDataApproval] = useState(null)
    const [dataInspeksiHasil, setDataInspeksiHasil] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!dataPrimer?.nomorAju || !dataDisposisi?.noTugas || dataDisposisi.idDisposisi !== 9) {
            return
        }

        try {
            const resUmkuHeader = await pbumkuService.getUmkuHeader(dataPrimer?.nomorAju)
            if (resUmkuHeader?.data) {
                if (dataPrimer?.asalData === 'O') {
                    const resInspeksi = await pbumkuService.getUmkuInspeksiDataByAjuAndNoSurat(dataPrimer.nomorAju, dataDisposisi.noTugas)

                    const [resOssHeader, resOssProyek, resJenisIzin, resApproval, resInspeksiHasil] = await Promise.all([
                        pbumkuService.getOssHeader(resUmkuHeader?.data?.idoss),
                        pbumkuService.findOssProyekById(resUmkuHeader?.data?.idpryk),
                        // pbumkuService.findOssChecklistById(resUmkuHeader?.data?.idchecklist),
                        pbumkuService.getRefPerizinan(jenisIzin),
                        pbumkuService.getUmkuApprovalByAju(dataPrimer?.nomorAju),
                        pbumkuService.getUmkuHasilInspeksiByAjuAndIdInspeksi(dataPrimer.nomorAju, resInspeksi?.data?.idInspeksi)
                    ])
                    const getData = (res, fallback = []) =>
                        res?.data?.data ?? res?.data ?? fallback;
                    setDataOssHeader(getData(resOssHeader))
                    setDataOssProyek(getData(resOssProyek))
                    // setDataOssChecklist(getData(resOssChecklist))
                    setDataIzin(getData(resJenisIzin))
                    setDataApproval(getData(resApproval))
                    setDataInspeksiHasil(getData(resInspeksiHasil))

                    let idProyek = resOssProyek?.data?.idProyek
                    const _listProyekLokasi = await pbumkuService.listOssProyekLokasi(idProyek)
                    // console.log(_listProyekLokasi.data)
                    setDataProyekLokasi(_listProyekLokasi?.data)
                } 
            }
        } catch (error) {

        }
    }, [dataPrimer, pbumkuService, jenisIzin, dataDisposisi])

    useEffect(() => {
        let isMounted = true
        if (!dataPrimer) return

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataPrimer, fetchAllData])

    return (
        <>
            <Modal
                show={showPreview}
                onHide={handleClosePreview}
                keyboard={false}
                size="xl"
                centered
            >
                <Modal.Body>
                    <PDFViewer style={{ width: 1105, height: 800 }}>
                        {
                            jenisIzin === 'CPIB' && dataPrimer?.asalData === 'O' &&
                            <LampTeknisCpib dataIzin={dataIzin} dataApproval={dataApproval} dataInpeksiHasil={dataInspeksiHasil} dataProyekLokasi={dataProyekLokasi}/>
                        }
                        {
                            jenisIzin === 'CBIB' && dataPrimer?.asalData === 'O' &&
                            <LampTeknisCbib dataIzin={dataIzin} dataApproval={dataApproval} dataInpeksiHasil={dataInspeksiHasil} dataProyekLokasi={dataProyekLokasi}/>
                        }
                        {
                            jenisIzin === 'CPPIB' && dataPrimer?.asalData === 'O' &&
                            <LampTeknisCppib dataIzin={dataIzin} dataApproval={dataApproval} dataOssHeader={dataOssHeader} dataProyek={dataOssProyek} dataProyekLokasi={dataProyekLokasi} dataInspeksiHasil={dataInspeksiHasil}/>
                        }
                        {
                            jenisIzin === 'CPOIB' && dataPrimer?.asalData === 'O' &&
                            <LampTeknisCpoib dataIzin={dataIzin} dataApproval={dataApproval} dataInspeksiHasil={dataInspeksiHasil}/>
                        }
                        {
                            jenisIzin === 'CDOIB' && dataPrimer?.asalData === 'O' &&
                            <LampTeknisCdoib dataIzin={dataIzin} dataApproval={dataApproval} dataInspeksiHasil={dataInspeksiHasil}/>
                        }
                    </PDFViewer>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalPreviewPdf